__turbopack_context__.v({
  "axisZero": "Walkthrough-module-scss-module__XVMA7G__axisZero",
  "cellArrayHoriz": "Walkthrough-module-scss-module__XVMA7G__cellArrayHoriz",
  "cellCircle": "Walkthrough-module-scss-module__XVMA7G__cellCircle",
  "cellInfoCol": "Walkthrough-module-scss-module__XVMA7G__cellInfoCol",
  "cellInfoCols": "Walkthrough-module-scss-module__XVMA7G__cellInfoCols",
  "cellInfoText": "Walkthrough-module-scss-module__XVMA7G__cellInfoText",
  "cellRect": "Walkthrough-module-scss-module__XVMA7G__cellRect",
  "externalLink": "Walkthrough-module-scss-module__XVMA7G__externalLink",
  "graph": "Walkthrough-module-scss-module__XVMA7G__graph",
  "graphBar": "Walkthrough-module-scss-module__XVMA7G__graphBar",
  "graphBarHit": "Walkthrough-module-scss-module__XVMA7G__graphBarHit",
  "graphBarLabel": "Walkthrough-module-scss-module__XVMA7G__graphBarLabel",
  "graphCol": "Walkthrough-module-scss-module__XVMA7G__graphCol",
  "table": "Walkthrough-module-scss-module__XVMA7G__table",
  "tableWrap": "Walkthrough-module-scss-module__XVMA7G__tableWrap",
  "tokIndex": "Walkthrough-module-scss-module__XVMA7G__tokIndex",
  "tokString": "Walkthrough-module-scss-module__XVMA7G__tokString",
});
